import React from 'react'
import { Parser } from '../../common'

const type = (type) => {
    const types = {
        Téléservice: 'Service en ligne',
        ServicePublic: 'Service-Public.fr',
    }

    return types[type] || type
}

const Source = ({ block }) => {
    return (
        <>
            {block?.content && <p className="baseocom-source-block">{type(block?.content)}</p>}
            {block?.childrens && <Parser content_block={block?.childrens} />}
        </>
    )
}

export default Source
